import React from "react";
import "./NewsSection.scss";
import GraduationImage from "../../assets/NewsImages/Graduation/graduationMain.jpg";
import DinnerImage from "../../assets/NewsImages/DinnerNight/dinnerNightMain.jpg";
import ElectionImage from "../../assets/NewsImages/Election/electionsMain.jpg";
import CharityImage from "../../assets/NewsImages/CharityDrive/charityMain.jpg";
import ChocolateImage from "../../assets/NewsImages/ChocolateDay/chocolateMain.jpg";
import FieldTripImage from "../../assets/NewsImages/FieldTrip/fieldTripMain.jpg";
import { Link } from "react-router-dom";

const NewsSection = () => {
  const news = [
    {
      slug: "2023-graduation-ceremony",
      image: GraduationImage,
      date: "29th September, 2023",
      title: "GRADUATION CEREMONY",
      description:
        "The school’s graduation where learners from the Foundation Class,Reception 2 and Grade 3 Class were graduated to the next higher class",
    },
    {
      slug: "dinner-night",
      image: DinnerImage,
      date: "28th September, 2023",
      title: "DINNER NIGHT",
      description:
        "Institutions do not exist in a vacuum. Every institution is an ‘Artificial Being’. The very existence of aninstitution is dependent on its stakeholders",
    },
    {
      slug: "student-leadership-elections-2023",
      image: ElectionImage,
      date: "Friday 8th September, 2023",
      title: "STUDENT LEADERSHIP ELECTIONS 2023",
      description:
        "Student leadership is one of the most important phases of every educational institution. The student leadersserve as the official mouthpiece of the student body.",
    },
    {
      slug: "anell-charity-drive",
      image: CharityImage,
      date: "Wednesday 7th June, 2023",
      title: "ANELL CHARITY DRIVE",
      description:
        "As part of the school’s 2nd Year Anniversary, the school embarked on a Charity drive to the NewLifeMissionary Home at Mbroum off Suame - Magazine road to make a donation to the children’s home. ",
    },
    {
      slug: "field-trip",
      image: FieldTripImage,
      date: "7th June, 2023",
      title: "FIELD TRIP",
      description:
        "As part of World’s Environmental Day and also to celebrate Green Ghana Day, our learners embarkedonanEducational trip to Council for Scientific Industrial Research at Fumesua, Kumasi.",
    },
    {
      slug: "anell-chocolate-day",
      image: ChocolateImage,
      date: "26TH MAY, 2023   /   MEDICAL SCREENING",
      title: "ANELL CHOCOLATE DAY",
      description:
        "Every 14th February is set aside as National Chocolate day in Ghana. This day was observed as suchbypupilsof Anell School of Excellence right from Preschool to the Grade school level.",
    },
  ];
  return (
    <div id="news" className="main-container">
      <div className="news-items">
        {news.map((newsItem, index) => (
          <div className="news-item" key={index}>
            <div
              className="news-item-header"
              style={{ backgroundImage: `url(${newsItem.image})` }}
            >
              {/* <img src={newsItem.image} alt="news-item" /> */}
            </div>
            <div className="news-item-body">
              <div className="date-title">{newsItem.date}</div>
              <div className="news-title">{newsItem.title}</div>
              <div className="news-body">{newsItem.description}</div>
              <Link to={`/news-events/news/${newsItem.slug}`}>READ MORE</Link>
            </div>
          </div>
        ))}
      </div>
      <div className="news-letter-section">
        <div className="news-letter-section-left">
          <h3>Newsletter</h3>
          <p>
          Stay in the know and be the first to hear about the latest news, trends, and exciting developments in your favorite niche! 
          </p>
        </div>
        <div className="news-letter-section-right">
          <form onSubmit={(e)=>e.preventDefault()}>
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Enter your email address here"
            />
            <input type="submit" value="SUBSCRIBE NOW" />
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewsSection;
